var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.42671,6L11.706,1.721C12.098,1.328,12.098,0.687,11.706,0.294C11.314,-0.098,10.6719,-0.098,10.2799,0.294L5.99963,4.574L1.72036,0.294C1.32733,-0.098,0.686293,-0.098,0.293268,0.294C-0.0977561,0.687,-0.0977561,1.328,0.293268,1.721L4.57254,6L0.293268,10.279C-0.0977561,10.671,-0.0977561,11.313,0.293268,11.706C0.686293,12.098,1.32733,12.098,1.72036,11.706L5.99963,7.426L10.2799,11.706C10.6719,12.098,11.314,12.098,11.706,11.706C12.098,11.313,12.098,10.671,11.706,10.279L7.42671,6Z",
    fillRule: "evenodd",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9cb53f563b5f88e7157e0d41312368f6.svg";
export { ForwardRef as ReactComponent };